import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import getQueryVariable from '../../../../../../ui-kitchen/src/utils/getQueryVariable';
import AmexLoading from '../../AmexMarketingUtils/AmexLoading';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import AmexResyCreditEligibleVenues from '../../AmexMarketingUtils/AmexResyCreditEligibleVenues';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import AmexPlatinumNightsCardRefresh from './AmexPlatinumNightsCardRefresh';
import AmexPlatinumNightsSelectorRefresh from '../AmexPlatinumNightsSelectorRefresh';
import {
  getPlatinumDetails, getMonthArray, getVenueDetails,
  findAllDisplayedCityNamesRefresh, isUserInPlatinumCity, getLocationArrayWithConfigData, getNoVenuesMessageData,
  getAllCitiesLocation, getUserPlatinumCity, shouldShowResyCreditSection, combineUniqueVenueLocationsWithBookableStatusAndLocations,
  isAllVenuesNotifyOrComingSoon, getFirstDayOfMonthFromName, getCurrentDateIfMonthIsCurrent,
} from '../PlatinumNights';
import {
  PARTY_SIZE, ALL_UPCOMING_MONTH, REQUIRED_KEY_AMOUNT,
} from '../constants';
import './AmexPlatinumNightsVenuesRefresh.scss';

const AmexPlatinumNightsVenuesRefresh = (
  {
    awsFolderName,
    baseRequestUrl,
    venuesConfig: {
      section_id: sectionId,
      section_title: sectionTitle,
      section_intro_1: sectionIntro1,
      section_intro_2: sectionIntro2,
      cta,
      section_logo: sectionLogo,
      mock_api_data_file: mockApiDataFile,
      more_button_label: moreButtonLabel,
      coming_soon_label: comingSoonLabel,
      book_label: bookLabel,
      notify_label: notifyLabel,
      platinum_cities: platinumCities = [],
      error_001_no_venues_filter: error001NoVenuesFilter = '',
      error_002_db_no_venues_city: error002DbNoVenuesCity = '',
      error_003_db_no_venues_all_cities: error003DbNoVenuesAllCities = '',
      filtering_help: filteringHelp,
      disable_filters_config: disableFiltersConfig = true,
    } = {},
    Analytics,
    loadNotifyModal,
    showAuthModal,
    allLocations,
    nearestWebLocation,
    isNonUS,
    venueDataValue,
    matchMedia,
    componentCallback,
    resyCreditContent = {},
    resyCreditContent: {
      hide_section: resyCreditHideSection,
    } = {},
    isCardMember,
    $rootScope,
    $routeParams,
  }
) => {
  const sanitizedSectionIntro1 = sanitizeString(sectionIntro1);
  const sanitizedSectionIntro2 = sanitizeString(sectionIntro2);

  const [venueDetails, setVenueDetails] = useState([]);
  const [filteredVenueDetails, setFilteredVenueDetails] = useState([]);
  const [locations, setLocations] = useState([]);
  const [platResponse, setPlatResponse] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [guests, setGuests] = useState('2');
  const [filterValueInComp, setFilterValueInComp] = useState(null);
  const [closestCity, setClosestCity] = useState([]);
  const [hideShowMoreButton, setHideShowMoreButton] = useState(true);
  const [startIndex, setStartIndex] = useState(4);
  const [displayedVenues, setDisplayedVenues] = useState([]);
  const [venuesMonths, setVenuesMonths] = useState([]);
  const [locationArr, setLocationArr] = useState([]);
  const [showStatusMessage, setShowStatusMessage] = useState(true);
  const [uniqueVenueLocationsWithBookableStatus, setUniqueVenueLocationsWithBookableStatus] = useState([]);
  const [showResyCredit, setShowResyCredit] = useState(false);
  const [combinedBookableLocations, setCombinedBookableLocations] = useState([]);
  const lastVenueRef = useRef(null);
  const timer = useRef(null);
  const testingValue = getQueryVariable('testing');
  const cityParam = getQueryVariable('city') || '';
  const monthParam = getQueryVariable('month') || '';
  const isDesktop = !!matchMedia.md;
  const logoImg = `${baseRequestUrl}${awsFolderName}/images/${sectionLogo}`;
  const updateDisplayedVenuesFeature = (venueInfo = [], indexValue = 4) => {
    if (venueInfo && venueInfo.length > indexValue) {
      setDisplayedVenues(venueInfo.slice(0, indexValue));
      setHideShowMoreButton(false);
    } else {
      setDisplayedVenues(venueInfo.slice(0));
      setHideShowMoreButton(true);
    }
  };

  const handleShowMoreVenues = () => {
    const nextStartIndex = startIndex + 4;
    setStartIndex(nextStartIndex);
    updateDisplayedVenuesFeature(filteredVenueDetails, nextStartIndex);
  };

  const handleFilterValue = async (filterValue) => {
    setStartIndex(4);
    setDisplayedVenues([]);
    setShowStatusMessage(false);
    let finalData = venueDetails?.slice(0);

    // If a new filterValue is selected, we need to check if the filterValue object has all the required 8 keys
    // before proceeding with filtering the venueDetails. If not, we return early without making any changes.
    if (Object.keys(filterValue).length !== REQUIRED_KEY_AMOUNT) return;

    setFilterValueInComp(filterValue);
    if (filterValue.size && (guests !== filterValue.size)) {
      setGuests(filterValue.size);
      setIsLoaded(false);
      setHideShowMoreButton(true);
      const response = await getVenueDetails(baseRequestUrl, platResponse, filterValue.size, isDesktop);
      setUniqueVenueLocationsWithBookableStatus(response?.uniqueVenueLocationsWithBookableStatus);
      finalData = response?.venues;
      setVenueDetails(response?.venues);
      setIsLoaded(true);
    }

    if (filterValue?.status && filterValue?.status !== '') {
      finalData = finalData.filter((parsedVenue) => parsedVenue.status === filterValue?.status);
    }

    if (filterValue?.slug && filterValue?.slug !== '') {
      finalData = finalData.filter((parsedVenue) => parsedVenue.locationSlug === filterValue?.slug);
    }

    if (filterValue?.month > ALL_UPCOMING_MONTH) {
      finalData = finalData.filter((parsedVenue) => {
        const venueDate = moment(parsedVenue.date, 'YYYY-MM-DD');
        const venueMonth = venueDate.month();
        if (venueMonth === filterValue?.month) {
          return parsedVenue;
        }
        return null;
      });
    }

    setFilteredVenueDetails(finalData);
    setShowResyCredit(shouldShowResyCreditSection({
      selectedSlug: filterValue?.slug || '',
      isCardMember,
      combinedBookableLocations,
      isFilterNoData: finalData?.length === 0 || isAllVenuesNotifyOrComingSoon(finalData),
    }));
    timer.current = setTimeout(() => setShowStatusMessage(true), 200);
  };

  const fetchData = async () => {
    const platinumResponse = await getPlatinumDetails(testingValue, baseRequestUrl, mockApiDataFile, venueDataValue);
    componentCallback('updatedHidePlatinumNights', false);
    setPlatResponse(platinumResponse);
    if (platinumResponse?.length > 0) {
      const response = await getVenueDetails(baseRequestUrl, platinumResponse, PARTY_SIZE, isDesktop);
      setUniqueVenueLocationsWithBookableStatus(response?.uniqueVenueLocationsWithBookableStatus);
      setVenueDetails(response?.venues);
      setVenuesMonths(getMonthArray(platinumResponse));
    }
    setLocationArr(getLocationArrayWithConfigData(platinumResponse, allLocations || [], platinumCities));
    setIsLoaded(true);
    componentCallback('isVenueDataLoaded', true);
  };

  useEffect(() => {
    const timeoutTimer = timer.current;
    fetchData();
    return () => clearTimeout(timeoutTimer);
  }, [allLocations]);

  useEffect(() => {
    const fetchDisplayedLocations = async () => {
      const allDisplayedLocations = await findAllDisplayedCityNamesRefresh(allLocations || [], locationArr);
      const userPlatinumCity = await getUserPlatinumCity(nearestWebLocation, allDisplayedLocations);
      if (!(allDisplayedLocations?.length > 1)) return;

      setLocations(allDisplayedLocations);

      let closeCity = null;
      if (isNonUS) closeCity = getAllCitiesLocation(allDisplayedLocations);
      else {
        const isUserInPlatCity = isUserInPlatinumCity(nearestWebLocation, allDisplayedLocations);
        if (isUserInPlatCity) {
          closeCity = userPlatinumCity;
        } else {
          closeCity = getAllCitiesLocation(allDisplayedLocations);
        }
      }

      setClosestCity(closeCity);
      const { url_slug: closeCitySlug, name: closeCityName, code: closeCityCode } = closeCity;
      handleFilterValue({
        slug: closeCitySlug || '',
        name: closeCityName || '',
        code: closeCityCode || '',
        disablingFilters: closeCity?.data === false,
        month: ALL_UPCOMING_MONTH,
        size: '2',
        monthFilter: '',
        status: '',
      });
      // show ResyCredit
      const combinedUniqueBookableLocations = combineUniqueVenueLocationsWithBookableStatusAndLocations(
        uniqueVenueLocationsWithBookableStatus,
        allDisplayedLocations
      );

      setCombinedBookableLocations(combinedUniqueBookableLocations);

      setShowResyCredit(shouldShowResyCreditSection({
        selectedSlug: filterValueInComp?.slug || closeCity?.url_slug || '',
        isCardMember,
        combinedBookableLocations,
      }));
    };
    fetchDisplayedLocations();
  }, [allLocations, locationArr]);

  useEffect(() => {
    if (locations?.length > 1 && venuesMonths) {
      const venuesMonthIndex = venuesMonths?.find((venuesMonthItem) => venuesMonthItem.label?.toUpperCase() === monthParam?.toUpperCase())?.value;

      const { url_slug: cityParamSlug, name: cityParamName, code: cityParamCode } = locations?.find((displayedLocItem) => displayedLocItem.url_slug === cityParam);
      const filterValueWithParam = {
        month: venuesMonthIndex - 1 || ALL_UPCOMING_MONTH,
        disablingFilters: false,
        monthFilter: venuesMonthIndex || '',
        slug: cityParamSlug || '',
        name: cityParamName || '',
        code: cityParamCode || '',
        size: '2',
        status: '',
      };

      handleFilterValue(filterValueWithParam);
    }
  }, [locations, venuesMonths]);

  useEffect(() => {
    updateDisplayedVenuesFeature(filteredVenueDetails);
  }, [filteredVenueDetails]);

  useEffect(() => {
    // set focus on the venue card after displayedVenues update
    if (lastVenueRef.current && startIndex > 4) {
      lastVenueRef.current.focus();
    }
  }, [displayedVenues]);

  const renderVenueGrid = () => displayedVenues?.map((restaurant, index) => restaurant && (
    <li
      key={restaurant?.venueName}
      {... (index === startIndex - 4 && startIndex > 4) && { tabindex: -1 }}
      ref={index === startIndex - 4 ? lastVenueRef : null}
    >
      <AmexPlatinumNightsCardRefresh
        baseRequestUrl={baseRequestUrl}
        showReservationList
        index={index}
        Analytics={Analytics}
        restaurant={restaurant}
        loadNotifyModal={loadNotifyModal}
        showAuthModal={showAuthModal}
        comingSoonLabel={comingSoonLabel}
        bookLabel={bookLabel}
        notifyLabel={notifyLabel}
        matchMedia={matchMedia}
      />
    </li>
  ));

  const renderErrorMessage = (noVenuesMessageData = {}) => {
    const {
      textBeforeLink, linkText, href, textAfterLink,
    } = noVenuesMessageData;
    const sanitizedTextBeforeLink = sanitizeString(textBeforeLink);
    const sanitizedLinkText = sanitizeString(linkText);
    const sanitizedTextAfterLink = sanitizeString(textAfterLink);

    return (
      <div className="AmexPlatinumNightsVenuesRefresh__notification-error">
        <p
          className="AmexPlatinumNightsVenuesRefresh__notification-error--text"
          role="status"
        >
          <span
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTextBeforeLink,
            }}
          />
          {sanitizedLinkText && (
          <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              const extraPrams = {
                action_name: 'Search Resy - Click',
              };
              handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraPrams);
            }}
          >
            {sanitizedLinkText}
          </Link>
          )}
          <span
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTextAfterLink,
            }}
          />
        </p>
      </div>
    );
  };

  const showErrorAndStatusMessage = () => {
    if (showStatusMessage) {
      const isFiltersDisabled = !!filterValueInComp?.disablingFilters;
      const selectedCitySlug = filterValueInComp?.slug || '';

      if (displayedVenues?.length === 0 && isFiltersDisabled && selectedCitySlug !== '') {
        const noVenuesMessageDataCity = getNoVenuesMessageData(selectedCitySlug, locations, error002DbNoVenuesCity);
        return renderErrorMessage(noVenuesMessageDataCity);
      }
      if (displayedVenues?.length === 0 && isFiltersDisabled && selectedCitySlug === '') {
        const noVenuesMessageDataAllCities = getNoVenuesMessageData(selectedCitySlug, locations, error003DbNoVenuesAllCities);
        return renderErrorMessage(noVenuesMessageDataAllCities);
      }
      if (displayedVenues?.length === 0) {
        const noVenuesMessageFilter = getNoVenuesMessageData(selectedCitySlug, locations, error001NoVenuesFilter);
        return renderErrorMessage(noVenuesMessageFilter);
      }
      return (
        <p className="AmexPlatinumNightsVenuesRefresh__venues-number sr-only">
          {`${filteredVenueDetails.length} venues.`}
        </p>
      );
    }
    // fixing VoiceOver's failure to repeat role status message when a different option is selected
    return (
      <span className="AmexPlatinumNightsVenuesRefresh__empty-content" />
    );
  };
  const displayCTA = (ctaObj) => {
    const { label, url } = ctaObj;
    if (!label || !url) return null;

    return (
      <Link
        href={url}
        className="AmexPlatinumNightsVenuesRefresh__link"
        target="_blank"
        onClick={() => {
          const extraPrams = {
            action_name: 'Add your eligible Card - Click',
          };
          handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraPrams);
        }}
      >
        {label}
      </Link>
    );
  };

  const renderResyCreditVenues = () => {
    const firstDateOfMonth = getFirstDayOfMonthFromName(filterValueInComp?.month);
    const currentDateOfMonth = getCurrentDateIfMonthIsCurrent(filterValueInComp?.month);

    const computedPageDate = currentDateOfMonth !== null ? currentDateOfMonth : firstDateOfMonth;
    const pageDate = computedPageDate || moment().format('YYYY-MM-DD');

    if (!resyCreditHideSection) {
      return (
        <AmexResyCreditEligibleVenues
          $rootScope={$rootScope}
          $routeParams={$routeParams}
          Analytics={Analytics}
          content={resyCreditContent}
          loadNotifyModal={loadNotifyModal}
          matchMedia={$rootScope?.matchMedia}
          showAuthModal={showAuthModal}
          pageLocation={filterValueInComp}
          pagePartySize={filterValueInComp?.size}
          pageDate={pageDate}
          cityName={filterValueInComp?.name}
          flowName={isCardMember ? 'CARD_MEMBER' : 'NON_CARD_MEMBER'}
        />
      );
    }
    return null;
  };

  return (
    <>
      <section className="AmexPlatinumNightsVenuesRefresh">
        <div className="container">
          <div className="AmexPlatinumNightsVenuesRefresh__top">
            <div className="AmexPlatinumNightsVenuesRefresh__top--copy">
              {sectionLogo && (
                <h2>
                  <img
                    id={sectionId}
                    src={logoImg}
                    alt={sectionTitle}
                    className="AmexPlatinumNightsVenuesRefresh__top--logo"
                  />
                </h2>
              )}
              {sanitizedSectionIntro1 && (
                <p
                  className="AmexPlatinumNightsVenuesRefresh__intro"
                >
                  <span
                    dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                      __html: sanitizedSectionIntro1,
                    }}
                  />
                  {cta && displayCTA(cta)}
                  {sanitizedSectionIntro2 && (
                    <span
                      dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                        __html: sanitizedSectionIntro2,
                      }}
                    />
                  )}
                </p>
              )}
            </div>
            {(locations?.length > 0) && (
              <AmexPlatinumNightsSelectorRefresh
                Analytics={Analytics}
                locations={locations}
                closestCity={closestCity}
                venuesMonths={venuesMonths}
                handleFilterValue={handleFilterValue}
                filterValueInComp={filterValueInComp}
                filteringHelp={filteringHelp}
                disableFiltersConfig={disableFiltersConfig}
              />
            )}
          </div>
          <div role="status" aria-atomic="true">
            {isLoaded && showErrorAndStatusMessage()}
          </div>
          {!isLoaded && <AmexLoading />}
          {(displayedVenues?.length > 0) && (
            <ul id="venuegrid" className="AmexPlatinumNightsVenuesRefresh__venuegrid">
              {renderVenueGrid()}
            </ul>
          )}
          {(!hideShowMoreButton) && (
            <Button
              variant="no-style"
              aria-label={`${moreButtonLabel} venues`}
              className="AmexPlatinumNightsVenuesRefresh__show-more"
              onClick={handleShowMoreVenues}
            >
              {moreButtonLabel}
            </Button>
          )}
        </div>
      </section>
      {showResyCredit && renderResyCreditVenues()}
    </>
  );
};

const mapStateToProps = (state) => {
  const isNonUS = state.ipdata?.isNonUS;
  const nearestWebLocation = isNonUS
    ? state.resyLocations?.nav?.find((location) => location.code === 'ny') || null
    : state.resyLocations?.all?.find((location) => location.show_on_web === 1)
      || state.resyLocations?.all?.[0]
      || null;

  return {
    allLocations: state.resyLocations?.all,
    nearestWebLocation,
    isNonUS,
    userDataInfo: state.user?.userData,
  };
};

export { AmexPlatinumNightsVenuesRefresh as ComponentAmexPlatinumNightsVenuesRefreshUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexPlatinumNightsVenuesRefresh);

AmexPlatinumNightsVenuesRefresh.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  venuesConfig: PropTypes.shape({
    section_id: PropTypes.string,
    section_title: PropTypes.string,
    section_intro_1: PropTypes.string,
    section_intro_2: PropTypes.string,
    cta: PropTypes.shape({}),
    sectionLogo: PropTypes.string,
  }).isRequired,
  resyCreditContent: PropTypes.shape({
    hide_section: PropTypes.bool,
  }).isRequired,
  $rootScope: PropTypes.shape({
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }),
    $digest: PropTypes.func,
  }).isRequired,
  loadNotifyModal: PropTypes.func.isRequired,
  showAuthModal: PropTypes.func.isRequired,
  allLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nearestWebLocation: PropTypes.shape({}),
  isNonUS: PropTypes.bool.isRequired,
  venueDataValue: PropTypes.shape({}).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  componentCallback: PropTypes.func.isRequired,
  isCardMember: PropTypes.bool,
  $routeParams: PropTypes.shape({}).isRequired,
};

AmexPlatinumNightsVenuesRefresh.defaultProps = {
  isCardMember: false,
  nearestWebLocation: null,
};
